import Autocomplete, {
  AutocompleteProps as MuiAutocompleteProps,
} from '@material-ui/lab/Autocomplete';

export type AutocompleteProps<T, Multiple extends boolean | undefined = undefined> =
  MuiAutocompleteProps<T, Multiple, undefined, undefined>;

export default Autocomplete;
